import { render, staticRenderFns } from "./orderListDialog.vue?vue&type=template&id=2e7bc27a"
import script from "./orderListDialog.vue?vue&type=script&lang=js"
export * from "./orderListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports